import { createApp } from "vue";
import App from "./App.vue";
import AppClr from "./AppClr.vue";
import axios from "axios";
import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import CmsPage from "./views/CmsPage.vue";
import TopView from "./components/TopView.vue";
import BottomView from "./components/BottomView.vue";
import LeftView from "./components/LeftView.vue";
import RightView from "./components/RightView.vue";
import { createI18n } from "vue-i18n";
import jQuery from "jquery";

axios.defaults.withCredentials = true;

// 添加请求拦截器，自动添加认证 token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const api = axios.create({
  baseURL: window.API_URL || "/api/",
});

// 为 api 实例也添加请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
window.$ = window.jQuery = jQuery;
const getWebConfig = () => {
  return api
    .get(window.WEB_TEMPLATE ? window.WEB_TEMPLATE : window.THEME ? "cms/web?theme=" + window.THEME : "cms/web")
    .then((response) => response.data)
    .catch((error) => {
      // Handle errors here, e.g., log or throw an error
      console.error("Error fetching web config:", error);
      throw error;
    });
};

async function addRoute(a) {
  if (Array.isArray(a)) {
    a.forEach((b) => {
      addRoute(b);
    });
  } else {
    a.components = { default: CmsPage, topview: TopView, bottomview: BottomView, leftview: LeftView, rightview: RightView };
  }
}

const numberFormats = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "zh-TW": {
    currency: {
      style: "currency",
      currency: "NTD",
      notation: "standard",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "ja-JP": {
    currency: {
      style: "currency",
      currency: "JPY",
      useGrouping: true,
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumSignificantDigits: 3,
      maximumSignificantDigits: 5,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
};

Date.prototype.format = function (format) {
  /*
   * eg:format="yyyy-MM-dd hh:mm:ss";
   */
  if (!format) {
    format = "yyyy-MM-dd hh:mm:ss";
  }

  var o = {
    "M+": this.getMonth() + 1, // month
    "d+": this.getDate(), // day
    "h+": this.getHours(), // hour
    "m+": this.getMinutes(), // minute
    "s+": this.getSeconds(), // second
    "q+": Math.floor((this.getMonth() + 3) / 3), // quarter
    "S+": this.getMilliseconds(),
    // millisecond
  };

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};


let lastErrorReportTs = 0;
function shouldReportError() {
  const now = Date.now();
  if (now - lastErrorReportTs < 60_000) {
    // 距離上次送出不到 1 分鐘，跳過
    return false;
  }
  lastErrorReportTs = now;
  return true;
}

getWebConfig().then((res) => {
  addRoute(res.route);
  if (window.DEBUG) console.log(res.route);
  let router = createRouter({
    history: window.WebHash ? createWebHashHistory() : createWebHistory(),
    routes: res.route,
  });

  const i18n = createI18n({
    numberFormats,
  });

  router.onError((err) => {
    if (!shouldReportError()) return;
    api.post("data/error-report", {
      type: "router-error",
      message: err.message,
      stack: err.stack,
      url: window.location.href,
      userAgent: navigator.userAgent,
    });
  });

  const app = window.AppClr ? createApp(AppClr) : createApp(App);
  app.config.globalProperties.$globalVariable = { ticket: 0, res: res };
  app.use(router).use(i18n);

  if (window.DEBUG) console.log(router.version);
  router.isReady().then(() => {
    // router.replace('/');  // 在路由準備好之後立即導航
    if (window.DEBUG) console.log(window.location.pathname);
    var launch = document.getElementById("launch");
    if (launch) launch.style.display = "none";
  });

  // 全域同步 JS 錯誤（如 script load、圖片 404）
  window.addEventListener("error", (event) => {
    if (!shouldReportError()) return;
    const { message, filename, lineno, colno, error } = event;
    
    // 偵測是否為跨域錯誤
    const isCrossOriginError = !filename || filename === '' || lineno === 0 || colno === 0;
    
    // 獲取當前載入的腳本資訊
    const getCurrentScripts = () => {
      try {
        const scripts = Array.from(document.scripts);
        return scripts.map(script => ({
          src: script.src,
          type: script.type,
          async: script.async,
          defer: script.defer,
          crossOrigin: script.crossOrigin,
          integrity: script.integrity,
          isExternal: script.src && script.src !== window.location.href,
          isInline: !script.src && script.textContent
        }));
      } catch (e) {
        return { error: 'Failed to get scripts info' };
      }
    };

    // 獲取路由資訊
    const getRouteInfo = () => {
      try {
        const currentRoute = router.currentRoute.value;
        return {
          path: currentRoute.path,
          name: currentRoute.name,
          params: currentRoute.params,
          query: currentRoute.query,
          meta: currentRoute.meta,
          fullPath: currentRoute.fullPath,
        };
      } catch (e) {
        return { error: 'Failed to get route info' };
      }
    };

    // 獲取性能資訊
    const getPerformanceInfo = () => {
      try {
        return {
          navigationStart: performance.timing?.navigationStart,
          loadEventEnd: performance.timing?.loadEventEnd,
          domContentLoaded: performance.timing?.domContentLoadedEventEnd,
          timestamp: Date.now(),
          memory: performance.memory ? {
            usedJSHeapSize: performance.memory.usedJSHeapSize,
            totalJSHeapSize: performance.memory.totalJSHeapSize,
            jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
          } : null,
        };
      } catch (e) {
        return { error: 'Failed to get performance info' };
      }
    };

    // 獲取錯誤代碼片段
    const getErrorCodeSnippet = (file, line, column) => {
      try {
        // 如果是內聯腳本，嘗試從 document.scripts 獲取
        if (file === '<anonymous>' || file.includes('eval')) {
          const scripts = Array.from(document.scripts);
          for (const script of scripts) {
            if (script.textContent) {
              const lines = script.textContent.split('\n');
              if (lines.length >= line) {
                const startLine = Math.max(0, line - 3);
                const endLine = Math.min(lines.length, line + 2);
                const snippet = lines.slice(startLine, endLine).map((content, index) => ({
                  lineNumber: startLine + index + 1,
                  content,
                  isErrorLine: startLine + index + 1 === line,
                  column: startLine + index + 1 === line ? column : null
                }));
                return { source: 'inline-script', snippet, errorLine: line, errorColumn: column };
              }
            }
          }
        } else if (file && (file.startsWith(window.location.origin) || file.startsWith('/'))) {
          // 對於外部文件，異步獲取
          fetch(file)
            .then(response => response.text())
            .then(content => {
              const lines = content.split('\n');
              if (lines.length >= line) {
                const startLine = Math.max(0, line - 3);
                const endLine = Math.min(lines.length, line + 2);
                const snippet = lines.slice(startLine, endLine).map((content, index) => ({
                  lineNumber: startLine + index + 1,
                  content,
                  isErrorLine: startLine + index + 1 === line,
                  column: startLine + index + 1 === line ? column : null
                }));
                
                // 異步更新錯誤報告
                api.post("data/error-report", {
                  type: "script-error-code-snippet",
                  originalError: message,
                  file,
                  snippet,
                  errorLine: line,
                  errorColumn: column,
                  routeInfo: getRouteInfo(),
                  performanceInfo: getPerformanceInfo(),
                  url: window.location.href,
                  userAgent: navigator.userAgent,
                  timestamp: new Date().toISOString(),
                  errorType: error?.name || 'Error',
                  errorCode: error?.code || null,
                  viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    devicePixelRatio: window.devicePixelRatio,
                  },
                  localStorageKeys: Object.keys(localStorage),
                  sessionStorageKeys: Object.keys(sessionStorage),
                });
              }
            })
            .catch(fetchErr => {
              console.warn('Failed to fetch source file:', fetchErr);
            });
        }
        return null;
      } catch (e) {
        return { error: 'Failed to get error code snippet' };
      }
    };

    api.post("data/error-report", {
      type: "script-error",
      message,
      file: filename,
      line: lineno,
      column: colno,
      stack: error?.stack,
      errorCodeSnippet: getErrorCodeSnippet(filename, lineno, colno),
      // 跨域錯誤相關資訊
      isCrossOriginError,
      crossOriginHint: isCrossOriginError ? "This appears to be a cross-origin script error. Add crossorigin='anonymous' to external scripts to get detailed error information." : null,
      currentScripts: getCurrentScripts(),
      routeInfo: getRouteInfo(),
      performanceInfo: getPerformanceInfo(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      errorType: error?.name || 'Error',
      errorCode: error?.code || null,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
      },
      localStorageKeys: Object.keys(localStorage),
      sessionStorageKeys: Object.keys(sessionStorage),
    });
  });

  // 未處理的 Promise Rejection
  window.addEventListener("unhandledrejection", (event) => {
    if (!shouldReportError()) return;
    const { message, filename, lineno, colno, error } = event;
    
    // 獲取路由資訊
    const getRouteInfo = () => {
      try {
        const currentRoute = router.currentRoute.value;
        return {
          path: currentRoute.path,
          name: currentRoute.name,
          params: currentRoute.params,
          query: currentRoute.query,
          meta: currentRoute.meta,
          fullPath: currentRoute.fullPath,
        };
      } catch (e) {
        return { error: 'Failed to get route info' };
      }
    };

    // 獲取性能資訊
    const getPerformanceInfo = () => {
      try {
        return {
          navigationStart: performance.timing?.navigationStart,
          loadEventEnd: performance.timing?.loadEventEnd,
          domContentLoaded: performance.timing?.domContentLoadedEventEnd,
          timestamp: Date.now(),
          memory: performance.memory ? {
            usedJSHeapSize: performance.memory.usedJSHeapSize,
            totalJSHeapSize: performance.memory.totalJSHeapSize,
            jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
          } : null,
        };
      } catch (e) {
        return { error: 'Failed to get performance info' };
      }
    };

    // 獲取錯誤代碼片段
    const getErrorCodeSnippet = (file, line, column) => {
      try {
        // 如果是內聯腳本，嘗試從 document.scripts 獲取
        if (file === '<anonymous>' || file.includes('eval')) {
          const scripts = Array.from(document.scripts);
          for (const script of scripts) {
            if (script.textContent) {
              const lines = script.textContent.split('\n');
              if (lines.length >= line) {
                const startLine = Math.max(0, line - 3);
                const endLine = Math.min(lines.length, line + 2);
                const snippet = lines.slice(startLine, endLine).map((content, index) => ({
                  lineNumber: startLine + index + 1,
                  content,
                  isErrorLine: startLine + index + 1 === line,
                  column: startLine + index + 1 === line ? column : null
                }));
                return { source: 'inline-script', snippet, errorLine: line, errorColumn: column };
              }
            }
          }
        } else if (file && (file.startsWith(window.location.origin) || file.startsWith('/'))) {
          // 對於外部文件，異步獲取
          fetch(file)
            .then(response => response.text())
            .then(content => {
              const lines = content.split('\n');
              if (lines.length >= line) {
                const startLine = Math.max(0, line - 3);
                const endLine = Math.min(lines.length, line + 2);
                const snippet = lines.slice(startLine, endLine).map((content, index) => ({
                  lineNumber: startLine + index + 1,
                  content,
                  isErrorLine: startLine + index + 1 === line,
                  column: startLine + index + 1 === line ? column : null
                }));
                
                // 異步更新錯誤報告
                api.post("data/error-report", {
                  type: "js-error-code-snippet",
                  originalError: message,
                  file,
                  snippet,
                  errorLine: line,
                  errorColumn: column,
                  routeInfo: getRouteInfo(),
                  performanceInfo: getPerformanceInfo(),
                  url: window.location.href,
                  userAgent: navigator.userAgent,
                  timestamp: new Date().toISOString(),
                  errorType: error?.name || 'Error',
                  errorCode: error?.code || null,
                  viewport: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                    devicePixelRatio: window.devicePixelRatio,
                  },
                  localStorageKeys: Object.keys(localStorage),
                  sessionStorageKeys: Object.keys(sessionStorage),
                });
              }
            })
            .catch(fetchErr => {
              console.warn('Failed to fetch source file:', fetchErr);
            });
        }
        return null;
      } catch (e) {
        return { error: 'Failed to get error code snippet' };
      }
    };

    api.post("data/error-report", {
      type: "js-error",
      message,
      file: filename,
      line: lineno,
      column: colno,
      stack: error?.stack,
      errorCodeSnippet: getErrorCodeSnippet(filename, lineno, colno),
      routeInfo: getRouteInfo(),
      performanceInfo: getPerformanceInfo(),
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      errorType: error?.name || 'Error',
      errorCode: error?.code || null,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
        devicePixelRatio: window.devicePixelRatio,
      },
      localStorageKeys: Object.keys(localStorage),
      sessionStorageKeys: Object.keys(sessionStorage),
    });
  });

  if(localStorage.getItem('res')) localStorage.removeItem('res')
  // 全域同步錯誤（component 渲染、生命週期等）
  // Vue3 提供 app.config.errorHandler
  app.config.errorHandler = (err, instance, info) => {
    if (!shouldReportError()) return;
  
    // 獲取組件路徑
    const getComponentPath = (comp) => {
      if (!comp) return null;
      const path = [];
      let current = comp;
      while (current) {
        const name = current.$options?.name || current.$options?.__name || current.$type?.name || 'Anonymous';
        path.unshift(name);
        current = current.$parent;
      }
      return path.join(' > ');
    };

    // 獲取路由資訊
    const getRouteInfo = () => {
      try {
        const currentRoute = router.currentRoute.value;
        return {
          path: currentRoute.path,
          name: currentRoute.name,
          params: currentRoute.params,
          query: currentRoute.query,
          meta: currentRoute.meta,
          fullPath: currentRoute.fullPath,
        };
      } catch (e) {
        return { error: 'Failed to get route info' };
      }
    };

    // 獲取性能資訊
    const getPerformanceInfo = () => {
      try {
        return {
          navigationStart: performance.timing?.navigationStart,
          loadEventEnd: performance.timing?.loadEventEnd,
          domContentLoaded: performance.timing?.domContentLoadedEventEnd,
          timestamp: Date.now(),
          memory: performance.memory ? {
            usedJSHeapSize: performance.memory.usedJSHeapSize,
            totalJSHeapSize: performance.memory.totalJSHeapSize,
            jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
          } : null,
        };
      } catch (e) {
        return { error: 'Failed to get performance info' };
      }
    };

    // 獲取出錯的 script 片段
    const getErrorCodeSnippet = (error) => {
      try {
        const stackLines = error.stack?.split('\n') || [];
        const errorInfo = {
          stackTrace: stackLines,
          codeSnippets: [],
          sourceFiles: []
        };

        // 解析堆疊追蹤中的文件位置
        for (const line of stackLines) {
          // 匹配文件路徑和行號列號
          const match = line.match(/at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
          if (match) {
            const [, functionName, filePath, lineNum, colNum] = match;
            const lineNumber = parseInt(lineNum);
            const columnNumber = parseInt(colNum);
            
            errorInfo.sourceFiles.push({
              functionName,
              filePath,
              lineNumber,
              columnNumber,
              fullLine: line.trim()
            });
          }
        }

        // 嘗試從第一個找到的文件獲取代碼片段
        if (errorInfo.sourceFiles.length > 0) {
          const firstFile = errorInfo.sourceFiles[0];
          
          // 如果是內聯腳本或 eval，嘗試從 document.scripts 獲取
          if (firstFile.filePath === '<anonymous>' || firstFile.filePath.includes('eval')) {
            const scripts = Array.from(document.scripts);
            for (const script of scripts) {
              if (script.textContent) {
                const lines = script.textContent.split('\n');
                if (lines.length >= firstFile.lineNumber) {
                  const startLine = Math.max(0, firstFile.lineNumber - 3);
                  const endLine = Math.min(lines.length, firstFile.lineNumber + 2);
                  const snippet = lines.slice(startLine, endLine).map((line, index) => ({
                    lineNumber: startLine + index + 1,
                    content: line,
                    isErrorLine: startLine + index + 1 === firstFile.lineNumber
                  }));
                  
                  errorInfo.codeSnippets.push({
                    source: 'inline-script',
                    snippet,
                    errorLine: firstFile.lineNumber
                  });
                  break;
                }
              }
            }
          } else {
            // 對於外部文件，嘗試通過 fetch 獲取（僅限同域）
            if (firstFile.filePath.startsWith(window.location.origin) || firstFile.filePath.startsWith('/')) {
              try {
                fetch(firstFile.filePath)
                  .then(response => response.text())
                  .then(content => {
                    const lines = content.split('\n');
                    if (lines.length >= firstFile.lineNumber) {
                      const startLine = Math.max(0, firstFile.lineNumber - 3);
                      const endLine = Math.min(lines.length, firstFile.lineNumber + 2);
                      const snippet = lines.slice(startLine, endLine).map((line, index) => ({
                        lineNumber: startLine + index + 1,
                        content: line,
                        isErrorLine: startLine + index + 1 === firstFile.lineNumber
                      }));
                      
                      // 異步更新錯誤報告
                      api.post("data/error-report", {
                        type: "vue-error-code-snippet",
                        originalError: error.message,
                        filePath: firstFile.filePath,
                        snippet,
                        errorLine: firstFile.lineNumber,
                        timestamp: new Date().toISOString()
                      });
                    }
                  })
                  .catch(fetchErr => {
                    console.warn('Failed to fetch source file:', fetchErr);
                  });
              } catch (fetchErr) {
                console.warn('Failed to fetch source file:', fetchErr);
              }
            }
          }
        }

        return errorInfo;
      } catch (e) {
        return { error: 'Failed to get error code snippet' };
      }
    };

    let payload = {};
    try {
      payload = {
        type: "vue-error",
        message: err.message,
        stack: err.stack,
        info, // hook 資訊：mounted、setup... 等
        component: instance?.$options?.name || "Anonymous",
        componentPath: (() => { try { return getComponentPath(instance); } catch { return null; } })(),
        routeInfo: (() => { try { return getRouteInfo(); } catch { return null; } })(),
        performanceInfo: (() => { try { return getPerformanceInfo(); } catch { return null; } })(),
        errorCodeSnippet: (() => { try { return getErrorCodeSnippet(err); } catch { return null; } })(),
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        // 額外的錯誤分類
        errorType: err.name || 'Error',
        errorCode: err.code || null,
        // 瀏覽器環境資訊
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
          devicePixelRatio: window.devicePixelRatio,
        },
        // 本地存儲狀態
        localStorageKeys: Object.keys(localStorage),
        sessionStorageKeys: Object.keys(sessionStorage),
      };
    } catch (payloadErr) {
      payload = {
        type: "vue-error",
        message: err.message,
        stack: err.stack,
        info,
        error: 'Failed to build payload',
        payloadError: payloadErr.message,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      };
    }

    try {
      api.post("data/error-report", payload).catch((e) => {
        // 若錯誤回報也出錯，只 log，不再 throw
        console.error("Error while reporting Vue error (async):", e);
      });
    } catch (reportErr) {
      // 若錯誤回報也出錯，可選擇 log 到 console（或寫入 localStorage）
      console.error("Error while reporting Vue error:", reportErr);
    }
  };
  
  app.mount("#app");
});
